const routes = {
  ADD: '/cases/add',
  ADDAGENCY: '/agencies/add',
  ALERTS: '/alerts/view',
  ALERTSCLOSED: '/alerts/view/:closed?',
  ALERTSBYCASE: '/case/alerts/:caseId',
  ADDALERT: '/alerts/add',
  ALERT_CONTROL_CENTER: '/alerts/control-center',
  CLOSE: '/close/:caseId',
  EDIT: '/case/edit/:caseId',
  EDITAGENCY: '/agencies/edit/:code',
  HOME: '/home',
  GLOBALDASHBOARD: '/globalDashboard',
  FOOTBALL_CARES: '/football-cares',
  FOOTBALL_CARES_CLUBS: '/football-cares/clubs',
  NOTIFICATIONS: '/home/notifications',
  LOGIN: '/login',
  PROVIDERS: '/admin/providers',
  ADMINSTATS: '/admin/stats',
  FINDSTATS: '/admin/findStats',
  PROVIDERSSTATS: '/admin/statsProviders',
  AUDITLOGS: '/admin/logs',
  LOGINLOGS: '/admin/loginLogs',
  RECOGNITIONLOGS: '/admin/recognitionLogs',
  ETLLOGS: '/admin/etlLogs',
  EMAILSCONFIGURATION: '/admin/emailsConfiguration',
  ALERTSSTATS: '/alerts/stats',
  ALERTGOOGLESTATS: '/alerts/stats/:caseId/:alertId',
  ROOT: '/',
  CASEVIEW: '/cases/view/:viewType',
  CASEDEFAULT: '/cases',
  AGENCIES: '/agencies',
  AGENCIESVIEW: '/agencies/view',
  AGENCYINFO: '/agencies/info/:code',
  HELP: '/help',
  HELP_ARTICLE_FORM: '/help/form/:categoryName/:categoryId/:articleId?',
  HELP_ARTICLE: '/help/article/:categoryName/:categoryId/:articleId',
  HELP_CATEGORY: '/help/category/:categoryId',
  UPLOADTERMSOFUSE: '/admin/termsOfUse',
  TERMSOFUSE: '/settings/termsOfUse',
  MANAGERSVIEW: '/agencies/managers/view',
  ADDMANAGER: '/agencies/managers/add',
  EDITMANAGER: '/agencies/managers/edit/:managerId',
  MANAGERINFO: '/agencies/managers/info/:managerId',
  CREATEALERT: '/alerts/add',
  CREATEALERTBYCASE: '/alerts/add/:caseId',
  EDITALERT: '/alerts/edit/:caseId/:alertId',
  REKOGNITION: '/rekognition',
  MANUALSEARCH: '/rekognition/search',
  MATCHESVIEW: '/rekognition/matches',
  MATCHESSTATS: '/rekognition/stats',
  MATCHESVIEWBIOMETRICA: '/rekognition/matches/biometrica',
  MATCHESCHILD: '/rekognition/matches/:caseId/:childId/:matchId',
  MATCHESADHOC: '/rekognition/matches/adhoc/:searchId/:matchId?',
  MATCHESBIOMETRICA: '/rekognition/matches/biometrica/:searchId',
  USERSETTINGS: '/settings',
  ADMINSETTINGS: '/admin',
  CASECHILDREN: '/case/children/:caseId',
  CASEINFO: '/case/information/:caseId',
  CASECOMPANIONS: '/case/companions/:caseId',
  CASEALERTS: '/case/alerts/:caseId',
  CASEMATCHES: '/case/matches/:caseId',
  CASEPOSTER: '/case/poster/:caseId',
  FORBIDDEN: '/forbidden',
  TRANSFERCASE: '/case/cross-border/:caseId',
  TRANSFERCASEADD: '/case/add-cross-border/:caseId',
  UPLOADCASES: '/settings/uploadcases',
  VISUAL_SEARCH: '/rekognition/visualsearch',
  GEOSEARCH_FORM: '/pdtr/form',
  GEOSEARCH_MANUAL_FORM: '/pdtr/manual',
  GEOSEARCH_RESULT: '/pdtr/result/:searchId',
  GEOSEARCH_STATS: '/pdtr/stats',
  GEOSEARCH_PHOTO: '/pdtr/photo/:photoId',
  GEOSEARCHES_VIEW: '/pdtr/view',
  NEWS: '/news',
  CLOSED_CASES_BULK: '/closed-cases-bulk',
  ADMINUSERS: '/admin/users',
  ADMINUSERSADD: '/admin/users/add',
  ADMINUSERSEDIT: '/admin/users/edit/:managerId',
  ADMINUSERSINFO: '/admin/users/info/:managerId',
  AUTH_CALLBACK: '/auth/callback',
}

export default routes;